module.exports = __webpack_public_path__ + "img/bosnia_and_herzegovina.171b591.webp";